import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import constants from '../constants'
import auth from '../auth'
import list from '../components/Training/list/lib'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authIdToken: null,
    authIdTokenTimestamp: null,
    signedIn: false,
    signInFail: null,
    user: {},
    training: {
      lessons: [],
      lessonsSrc: []
    }
  },
  plugins: [
    createPersistedState({
      key: 'auth',
      paths: [
        'signedIn',
        'authIdToken',
        'authIdTokenTimestamp'
      ]
    })
  ],
  mutations: {
    // AUTH
    [constants.SIGN_IN] (state, payload) {
      state.signedIn = true
      state.user = payload
    },
    [constants.SIGN_OUT] (state, payload) {
      if (payload) {
        state.signInFail = payload
      }
      auth.signOut()
      state.signedIn = false
    },

    // TRAINING
    [constants.SET_LESSONS] (state, payload) {
      state.training.lessons = payload
    },
    [constants.SET_LESSONS_SRC] (state, payload) {
      state.training.lessonsSrc = payload
    },
    [constants.NEW_LESSON] (state, payload) {
      state.training.lessonsSrc.push(payload)
      state.training.lessons = list.buildCatTree(state.training.lessonsSrc, 'academy')
    },
    [constants.SAVE_ID_TOKEN] (state, payload) {
      state.authIdToken = payload
      state.authIdTokenTimestamp = new Date().getTime()
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/state/index.js